import QRCode from "easyqrcodejs"
import { initBookmarks } from "../bookmarks/advert-page/bookmarks.ts"
import { LadiesMain } from "../global/ladies-main"
import { getCurrentBreakpoint } from "../util/responsive"
import { initBusinessHours } from "./business-hours.ts"
import { calculateMoreContentHeights, initializeSpecialsMoreButtons } from "./fkk-more-specials.ts"
import { initGallery, initSharedGallery } from "./gallery/gallery.ts"
import { initGoogleMaps } from "./google-maps.ts"
import { initKolleginLink } from "./kollegin-link/kollegin-link.ts"
import { initStickySidebar } from "./sticky-sidebar.ts"
import { initWhatsAppPopup } from "./whatsapp-popup.ts"
import "../bookmarks/advert-page/tags-panel.ts"
import "./crawler-protection"

class SinglePageClass {
    currentViewport = getCurrentBreakpoint()

    constructor() {
        const init = this.init.bind(this)

        $(document).on(
            "show.more:transition",
            function () {
                this.registerTextEvents(true)
            }.bind(this),
        )

        $(() => {
            init()
        })
    }

    window = $(window)

    galleryThumbClass = "gallery-thumbnail"

    initializeLimitedText() {
        let height
        let lines
        let maxLines = ""
        const filler = "Xg<br>"
        const limitedElements = $(".limit-text-height")

        limitedElements.each(function () {
            lines = Number.parseInt($(this).data("lines"), 10)

            if (lines > 0) {
                maxLines = filler.repeat(lines)
                $(this).append(`<span class="limit-text-height-temp">${maxLines}</span>`)
                height = $(".limit-text-height-temp").height() + Number.parseInt($(this).css("paddingTop"), 10)
                $(this).css({ height: height })
                $(".limit-text-height-temp").remove()
            }
        })
    }

    /**
     * Füge den Solads-Banner auf dem Platz 3 in der Galerie
     *
     * @private
     * @param {Event} initEvent
     * @param {Object} gallery
     */
    addSolToGallery(initEvent, gallery) {
        const thumbnailContainer = gallery.sliderContainer.find(".rsThumbsContainer")
        let solThumbnails
        let solSlide
        const bannerPositionIndex = 2
        const minPhotos = 5

        this.addBaseClassToGalleryThumbnails(thumbnailContainer)

        if (!("solGallery" in siteConfig) || !siteConfig.solGallery.length) {
            return
        }

        if (gallery.slider.numSlides < minPhotos || gallery.slider.numSlides < bannerPositionIndex) {
            return
        }

        siteConfig.solGallery.forEach(
            function (solItem) {
                solSlide = $("<div />")
                solSlide
                    .addClass("galleryContent rsContent additional-banner")
                    .attr("data-caption", '<div class="imageCountInner">Anzeige</div>')
                    .append(solItem)

                window.setTimeout(
                    function () {
                        gallery.anzeigeCount++

                        gallery.slider.appendSlide(solSlide, bannerPositionIndex)
                        gallery.slider.updateSliderSize(true)

                        solThumbnails = thumbnailContainer.find(
                            `.rsThumb:not(.${this.galleryThumbClass}):not(.adsrv-thumbnail)`,
                        )

                        solThumbnails
                            .addClass("sol-thumbnail")
                            .find(".thumbIco")
                            .append('<span class="thumb-text">Anzeige</span>')
                    }.bind(this),
                    15,
                )
            }.bind(this),
        )
    }

    addAdsrvBannerToGallery(initEvent, gallery) {
        const thumbnailContainer = gallery.sliderContainer.find(".rsThumbsContainer")
        let solThumbnails
        let solSlide
        const minPhotos = 1

        this.addBaseClassToGalleryThumbnails(thumbnailContainer)

        if (!("solGallery" in siteConfig) || !siteConfig.solGallery.length) {
            return
        }

        if (gallery.slider.numSlides < minPhotos) {
            return
        }

        siteConfig.solGallery.forEach(
            function (solItem) {
                solSlide = $("<div />")
                solSlide
                    .addClass("galleryContent rsContent additional-banner")
                    .attr("data-caption", '<div class="imageCountInner">Anzeige</div>')
                    .append(solItem)

                window.setTimeout(
                    function () {
                        gallery.anzeigeCount++

                        gallery.slider.appendSlide(solSlide)
                        gallery.slider.updateSliderSize(true)

                        solThumbnails = thumbnailContainer.find(
                            `.rsThumb:not(.${this.galleryThumbClass}):not(.adsrv-thumbnail)`,
                        )

                        solThumbnails
                            .addClass("sol-thumbnail")
                            .find(".thumbIco")
                            .append('<span class="thumb-text">Anzeige</span>')
                    }.bind(this),
                    15,
                )
            }.bind(this),
        )
    }

    /**
     * @private
     * @param {jQuery} container
     */
    addBaseClassToGalleryThumbnails(container) {
        container.find(".rsThumb").addClass(this.galleryThumbClass)
    }

    /** ##  Methods  ## **/
    /**
     * Initialisierungs-Methode
     */
    init() {
        initBusinessHours()
        initStickySidebar()
        initBookmarks()
        initGoogleMaps()
        initKolleginLink()
        initGallery()
        initSharedGallery()
        initializeSpecialsMoreButtons()
        initWhatsAppPopup()

        this.toggleMoreProfileDataEvents()
        this.initializeLimitedText()
        this.registerUrlClickEvent()
        this.registerDetailedTraitsClickEvent()
        this.registerDetailedOpeningsClickEvent()
        this.registerMoreTextEvent()
        this.registerMoreEventTextEvent()
        this.registerFkkMobileCollapseEvent()
        this.registerMoreGlobalTextEvent()
        this.registerCreatorLinksModalUrlEvents()
        this.initShareModalQrCode()

        calculateMoreContentHeights()

        $(window).trigger("scroll")

        LadiesMain.windowResized.attach(() => {
            // Viewport changed
            if (this.currentViewport !== getCurrentBreakpoint()) {
                // More text
                this.registerTextEvents()

                // Save actual Vieport
                this.currentViewport = getCurrentBreakpoint()
            }
        })

        $(window).trigger("scroll")

        if (!SiteInfo.isMobileVersion) {
            if (!("gallery" in siteConfig) || !siteConfig.gallery.instance) {
                $(document).one("init:gallery.royal-slider", this.addSolToGallery.bind(this))
                $(document).one("init:gallery.royal-slider", this.addAdsrvBannerToGallery.bind(this))
            } else {
                this.addSolToGallery(null, siteConfig.gallery.instance)
                this.addAdsrvBannerToGallery(null, siteConfig.gallery.instance)
            }
        }
    }

    /**
     * @private
     * @param {boolean} [keepTextOpen]
     */
    registerTextEvents(keepTextOpen) {
        this.registerMoreGlobalTextEvent(keepTextOpen || false)
        this.registerMoreEventTextEvent()
        this.registerMoreTextEvent()

        calculateMoreContentHeights()
    }

    /**
     * Finde alle Elemente mit .adjust-height und Registriere ein Event, wenn man den 'Ganzen Text einblenden' oder 'Text ausblenden' klickt.
     */
    registerMoreGlobalTextEvent(k) {
        // $(window).on("load", function() {
        const arrElemente = $(".adjust-height")
        const btn = $(".btn-more-globaltext")
        let moreTextEventInProgress = false

        let keepTextOpen = k
        if (!keepTextOpen) {
            keepTextOpen = false
        }

        /* Finde alle Elemente und überprüfe die Höhe*/
        $.each(arrElemente, (key, values) => {
            const adjustHeightElement = $(values)

            if (keepTextOpen && true === adjustHeightElement.data("heightCalculated")) {
                return
            }

            const strId = `#${values.id}`
            const elHeight = $(`${strId} .ah-height`).height()
            const stringAdjust = `${strId} .ah-adjust`

            $(stringAdjust).css("height", "auto") // Reset Height!!!

            const elAdjustHeight = $(stringAdjust).height()
            const elTrans = $(`${strId} .text-trans`)
            const elBtn = $(`${strId} .btn-more-globaltext`)

            if (elAdjustHeight > elHeight) {
                const elAdjust = $(stringAdjust)
                const elAdjustH = elHeight - 27 // Buttonhöhe abziehen
                elBtn.addClass("less")
                elBtn.css("display", "inline-block")
                elBtn.attr("data-height", elAdjustHeight)
                elTrans.css("display", "block")
                elAdjust.css("height", `${elAdjustH}px`)
            } else {
                elBtn.css("display", "none")
                elTrans.css("display", "none")
            }

            if (elHeight > 0) {
                adjustHeightElement.data("heightCalculated", true)
            }
        })

        btn.off("click")
        btn.click(function (e) {
            if (true === moreTextEventInProgress) {
                e.preventDefault()
                return false
            }

            moreTextEventInProgress = true
            e.stopImmediatePropagation()

            const clickId = $(this).data("auftrags-id")
            const clickOrgHeight = $(this).data("height")
            const clickHeight = $(`#adjustHeight${clickId} .ah-height`).height() - 27
            const clickTrans = $(`#adjustHeight${clickId} .text-trans`)
            const clickBtn = $(`#adjustHeight${clickId} .btn-more-globaltext`)
            const clickAdjust = $(`#adjustHeight${clickId} .ah-adjust`)
            if (clickBtn.hasClass("less")) {
                clickTrans.css("display", "none")
                clickBtn.removeClass("less")
                clickBtn.addClass("more")
                clickAdjust.css("max-height", "none")
                clickAdjust.animate({ height: clickOrgHeight }, 300, () => {
                    clickBtn.text("Text ausblenden")
                    moreTextEventInProgress = false
                })
            } else {
                clickBtn.addClass("less")
                clickBtn.removeClass("more")
                const scPos = $(window).scrollTop()
                const elPos = $(`#adjustHeight${clickId}`).offset().top - 57
                if (scPos > elPos) {
                    $("html,body").animate({ scrollTop: elPos }, 100, () => {
                        clickAdjust.animate({ height: `${clickHeight}px` }, () => {
                            clickBtn.text("Ganzen Text einblenden")
                            moreTextEventInProgress = false

                            $(window).trigger("scroll")
                        })
                    })
                } else {
                    clickAdjust.animate({ height: `${clickHeight}px` }, () => {
                        clickBtn.text("Ganzen Text einblenden")
                        moreTextEventInProgress = false

                        $(window).trigger("scroll")
                    })
                }
                clickTrans.css("display", "block")
            }

            return false
        })
    }

    /**
     * Registriere ein Event, wenn man den 'Ganzen Text einblenden' oder 'Text ausblenden' klickt.
     */
    registerMoreEventTextEvent() {
        const text = $(".topeventtext")
        const btn = $(".btn-more-eventtext")
        const trans = $(".topevent .text-trans")
        let maxHeight = 120
        let moreTextEventInProgress = false
        if (getCurrentBreakpoint() === "md") {
            maxHeight = 114
        }

        if (["xs", "sm"].includes(getCurrentBreakpoint())) {
            maxHeight = 84
        }

        if (!text.length) {
            return
        }

        const h = text[0].scrollHeight

        if (h > maxHeight) {
            btn.addClass("less")
            btn.css("display", "inline-block")
            trans.css("display", "block")
            text.css("height", maxHeight)
        }

        btn.off("click")
        btn.click((e) => {
            if (true === moreTextEventInProgress) {
                e.preventDefault()
                return false
            }

            moreTextEventInProgress = true
            // e.stopPropagation();
            e.stopImmediatePropagation()

            if (btn.hasClass("less")) {
                trans.css("display", "none")
                btn.removeClass("less")
                btn.addClass("more")
                text.css("max-height", "none")
                text.animate({ height: h }, 300, () => {
                    btn.text("Text ausblenden")
                    moreTextEventInProgress = false
                })
            } else {
                btn.addClass("less")
                btn.removeClass("more")
                const scPos = $(window).scrollTop()
                const elPos = $(".topevent .datum").offset().top - 57
                if (scPos > elPos) {
                    $("html,body").animate({ scrollTop: elPos }, 100, () => {
                        text.animate({ height: `${maxHeight}px` }, () => {
                            btn.text("Ganzen Text einblenden")
                            moreTextEventInProgress = false

                            $(window).trigger("scroll")
                        })
                    })
                } else {
                    text.animate({ height: `${maxHeight}px` }, () => {
                        btn.text("Ganzen Text einblenden")
                        moreTextEventInProgress = false

                        $(window).trigger("scroll")
                    })
                }
                trans.css("display", "block")
            }

            return false
        })
    }

    /**
     * Registriere ein Event, wenn man den 'Ganzen Text einblenden'
     *    oder 'Text ausblenden' klickt
     */
    registerMoreTextEvent() {
        const text = $(".text-overflow")
        const btn = $(".btn-more-text")
        const contentProfil = $(".einzel-content .einzelansicht-attributes")
        const trans = $(".text-overflow .text-trans")
        let maxHeight = 443
        let addToScrollTop = false
        let moreTextEventInProgress = false

        if (!text.length || text.hasClass("open")) {
            return
        }

        if (contentProfil.length > 0 && contentProfil.height() > maxHeight) {
            maxHeight = contentProfil.height()

            text.css("maxHeight", maxHeight)
            addToScrollTop = true
        }

        const realHeight = text[0].scrollHeight

        if (realHeight > maxHeight) {
            btn.addClass("less")
            btn.removeClass("more")
            btn.text("Ganzen Text einblenden")

            btn.css("display", "inline-block")
            trans.css("display", "block")
            text.css("height", maxHeight)
        }

        btn.off("click")
        btn.click((e) => {
            if (true === moreTextEventInProgress) {
                e.preventDefault()
                return false
            }

            moreTextEventInProgress = true

            e.stopImmediatePropagation()

            if (btn.hasClass("less")) {
                btn.removeClass("less")
                btn.addClass("more")
                trans.css("display", "none")
                text.css("max-height", "none")
                text.addClass("open")

                text.animate({ height: realHeight }, 300, () => {
                    btn.text("Text ausblenden")
                    moreTextEventInProgress = false
                })
            } else {
                const scPos = $(window).scrollTop()
                const elPos = $(".kuenstlername:visible").offset().top - 57
                let newScrollTop = elPos

                btn.addClass("less")
                btn.removeClass("more")
                text.removeClass("open")

                if (scPos > elPos + (addToScrollTop ? maxHeight : 0)) {
                    if (addToScrollTop) {
                        newScrollTop = text.offset().top + maxHeight + btn.height() + 57
                        newScrollTop -= window.innerHeight

                        if (newScrollTop < elPos) {
                            newScrollTop = elPos
                        }
                    }

                    $("html,body").animate({ scrollTop: newScrollTop }, 200, () => {
                        text.animate({ height: `${maxHeight}px` }, () => {
                            btn.text("Ganzen Text einblenden")
                            moreTextEventInProgress = false
                        })
                    })
                } else {
                    text.animate({ height: `${maxHeight}px` }, () => {
                        btn.text("Ganzen Text einblenden")
                        moreTextEventInProgress = false
                    })
                }

                trans.css("display", "block")
            }

            return false
        })
    }

    /**
     * Registriere ein Event, wenn man auf die Karte-URL geklickt hat.
     * Danach scrolle zu Karte.
     */
    registerUrlClickEvent() {
        const tracker = window.Tracking

        if (!tracker || !tracker.trackAnzeigenlink) {
            return
        }

        $("a.einzelansicht-url").click(tracker.trackAnzeigenlink)
    }

    /**
     * Registriere ein Event, wenn man auf die mehr-URL bei Short-Merkmale geklickt hat.
     * Danach scrolle zu Merkmale.
     */
    registerDetailedTraitsClickEvent() {
        $(".profil a.more-link").click(() => {
            $("html,body").animate({ scrollTop: $("#attribute").offset().top }, "slow")
            return false
        })
    }

    /**
     * Registriere ein Event, wenn man auf die mehr-Zeiten bei Kontakt-Container geklickt hat.
     * Danach scrolle zu Zeiten.
     */
    registerDetailedOpeningsClickEvent() {
        $("a.einzelansicht-zeiten").click(function () {
            let hrefAttr = $(this).attr("href")
            hrefAttr = hrefAttr.split("#")[1]

            $("html,body").animate({ scrollTop: $(`#${hrefAttr}`).offset().top }, "slow")
            return false
        })
    }

    /**
     * Zeige/verstecke weitere Profildaten
     */
    toggleMoreProfileDataEvents() {
        const profilHeight = $("#profilAttributes").height()
        let profilOpened = false

        $("#toggleProfileButton").click(() => {
            const attributeElement = $("#profilAttributes")

            if (profilOpened === false) {
                let childrenHeight = 0

                // hole die Höhe von Kinder-Elemente
                attributeElement.children().each(function () {
                    childrenHeight += $(this).height()
                })

                attributeElement.animate({ height: childrenHeight }, 200)
                profilOpened = true
            } else {
                attributeElement.animate({ height: profilHeight }, 200)
                profilOpened = false
            }

            return false
        })
    }

    registerFkkMobileCollapseEvent() {
        const textContainers = document.getElementsByClassName("fkk-text-container")
        const eventTextContainers = document.getElementsByClassName("fkk-event-text-container")

        for (const container of textContainers) {
            const collapseBtn = container.querySelector(".fkk-collapse-button")
            const textElement = container.querySelector(".fkk-text")
            let originalTextHeight = 0

            if (textElement.scrollHeight === Math.max(textElement.offsetHeight, textElement.clientHeight)) {
                collapseBtn.style.display = "none"
                continue
            }

            collapseBtn.addEventListener("click", (e) => {
                if (originalTextHeight !== 0 && textElement.getBoundingClientRect().height > originalTextHeight) {
                    textElement.style.height = `${originalTextHeight}px`
                    collapseBtn.innerHTML = "Ganzen Text einblenden"
                } else {
                    textElement.style.height = `${textElement.scrollHeight}px`
                    collapseBtn.innerHTML = "Text ausblenden"
                    originalTextHeight = textElement.getBoundingClientRect().height
                }
            })
        }

        for (const container of eventTextContainers) {
            const collapseBtn = container.querySelector(".fkk-event-collapse-button")
            const textElement = container.querySelector(".fkk-event-text")

            textElement.style.height = "0px"

            textElement.addEventListener("transitionend", () => {
                if (collapseBtn.innerHTML === "Mehr Informationen") {
                    textElement.style.display = "none"
                }
            })

            collapseBtn.addEventListener("click", (e) => {
                if (textElement.getBoundingClientRect().height > 108) {
                    textElement.style.height = "0px"
                    collapseBtn.innerHTML = "Mehr Informationen"
                } else {
                    textElement.style.display = "inline-block"
                    textElement.style.height = `${textElement.scrollHeight}px`
                    collapseBtn.innerHTML = "Weniger Informationen"
                }
            })
        }
    }

    registerCreatorLinksModalUrlEvents() {
        const creatorLinks = document.querySelectorAll('a.creator-link[data-target="#leave-page-modal"]')

        for (const link of creatorLinks) {
            link.addEventListener("click", function () {
                document.querySelector("#leave-page-modal-url").setAttribute("href", this.href)
            })
        }

        document.querySelector("#leave-page-modal-url")?.addEventListener("click", () => {
            $("#leave-page-modal").modal("hide")
        })
    }

    initShareModalQrCode() {
        const shareModal = document.getElementById("merkzettel-modal-share")
        if (!shareModal) {
            return
        }

        const shareModalQrContainer = shareModal.querySelector(".qr-code")
        if (!shareModalQrContainer) {
            return
        }

        /** @type {HTMLInputElement|null} */
        const urlLinkInput = shareModal.querySelector(".form-control.merkzettel-link")
        if (!urlLinkInput) {
            return
        }

        new QRCode(shareModalQrContainer, {
            text: urlLinkInput.value,
        })
    }
}

export const SinglePage = new SinglePageClass()
